module.exports = __webpack_public_path__ + "img/Illustration-problem.b34e4e8.png";